// Length Warnings
export const HEADLINE_FIRST_WARNING = 50;
export const HEADLINE_SECOND_WARNING = 70;
export const KEEP_READING_SHORT_CHAR_LIMIT = 12;
export const KEEP_READING_LONG_CHAR_LIMIT = 20;
export const OG_ALT_TEXT_WARNING = 60;
export const OG_HEADLINE_WARNING = 95;
export const OG_DESCRIPTION_WARNING = 60;
export const SEO_HEADLINE_WARNING = 70;
export const URL_SLUG_WARNING = 50;

// Editor Modals
export const EDITOR_MODALS = {
  EMBED_EDITOR: "embedEditor",
  LINK_EDITOR: "linkEditor",
  NEWSLETTER_CTA_EDITOR: "newsletterCTAEditor",
  CLOSE: false,
};

// Block Types
export const BLOCK_TYPE = {
  // defaults from draft.js
  UNSTYLED: "unstyled",
  SUBHEAD: "header-two",
  UNORDERED_LIST_ITEM: "unordered-list-item",
  ORDERED_LIST_ITEM: "ordered-list-item",

  // custom block types
  EMBED: "embed",
  PLAIN_QUOTE: "plain-quote",
  QUOTE_ATTRIBUTION: "quote-attribution",
  IMAGE: "image",
  KEEP_READING: "keep-reading",
  AXIOM: "axiom",
};

// Special block handling
export const ON_RETURN = {
  NEXT_BLOCK_UNSTYLED: [
    BLOCK_TYPE.QUOTE_ATTRIBUTION,
    BLOCK_TYPE.IMAGE,
    BLOCK_TYPE.EMBED,
    BLOCK_TYPE.SUBHEAD,
    BLOCK_TYPE.AXIOM,
  ],
  HANDLE_QUOTE: [BLOCK_TYPE.PLAIN_QUOTE],
};

export const SELECTABLE_BLOCKS = [
  BLOCK_TYPE.EMBED,
  BLOCK_TYPE.IMAGE,
  BLOCK_TYPE.KEEP_READING,
];
export const CAPTION_BLOCKS = [
  BLOCK_TYPE.QUOTE_ATTRIBUTION,
  BLOCK_TYPE.EMBED,
  BLOCK_TYPE.IMAGE,
];
export const BLOCKS_WITH_DATA = [
  BLOCK_TYPE.EMBED,
  BLOCK_TYPE.IMAGE,
  BLOCK_TYPE.AXIOM,
  BLOCK_TYPE.KEEP_READING,
];
export const INLINE_TOOLS_ONLY_BLOCKS = [
  BLOCK_TYPE.IMAGE,
  BLOCK_TYPE.EMBED,
  BLOCK_TYPE.AXIOM,
];

// Atomic Unit
export const ATOMIC_UNIT_CHARACTER_LIMIT = 600;
export const ATOMIC_UNIT_LINE_BREAK_LIMIT = 6;
export const EMBED_OR_IMAGE_CHARACTER_COUNT = 200;

// ENTITY_TYPES
export const ENTITY_TYPE = {
  LINK: "LINK",
  OLD_LINK: "link",
};

// Custom Key Commands
export const KEY_COMMANDS = {
  LINK: "insert-link",
};

// Timing.
export const AUTOSAVE_INTERVAL = 10;
export const CHECK_LOCK_INTERVAL = 5;

// Placeholders
export const QUOTE_PLACEHOLDER = "Type your quote";
export const EMBED_CAPTION_PLACEHOLDER = "Add a credit and data source";
export const IMAGE_CAPTION_PLACEHOLDER = "Add a caption and photo credit";
export const ATTRIBUTION_PLACEHOLDER = "Add an optional attribution";
export const OG_ALT_TEXT_PLACEHOLDER = "Add social image alt text";
export const OG_HEADLINE_PLACEHOLDER = "Add a social headline";
export const OG_DESCRIPTION_PLACEHOLDER = "Add a social description";
export const URL_SLUG_PLACEHOLDER = "Add a custom URL slug";
export const STORY_PLACEHOLDER = "Type your story";
export const FACTS_MATTER_PLACEHOLDER =
  "Type a lede to get started. Use the H2 tool to insert a subheader for “Why it matters” and any additional parts.";
export const ALERT_SUBJECT_PLACEHOLDER = "Type your subject line";
export const ALERT_BODY_PLACEHOLDER = "Type your alert body";
export const ALERT_SELECT_PLACEHOLDER = "Select one or more lists";
export const NEWSLETTER_INTRO_PLACEHOLDER = "Introduce your newsletter";
export const NEWSLETTER_OUTRO_PLACEHOLDER = "Conclude your newsletter";
export const NEWSLETTER_AUTHOR_PLACEHOLDER = "Type an author";
export const NEWSLETTER_EDITOR_PLACEHOLDER = "Add an editor";
export const NEWSLETTER_SELECT_PLACEHOLDER = "Select a newsletter";
export const NEWSLETTER_SUBJECT_PLACEHOLDER = "Type your subject line";
export const NEWSLETTER_PREVIEW_PLACEHOLDER = "Add preview text";
export const NEWSLETTER_CHUNK_PLACEHOLDER = "Type your item";
export const NEWSLETTER_PUSH_NOTIFICATION_PLACEHOLDER =
  "Add push notication text";
export const SEO_HEADLINE_PLACEHOLDER = "Add an SEO headline";

export const FACEBOOK_SDK_VERSION = "v2.10";

export const EMBED_DEPENDENCY = {
  TWITTER: "https://platform.twitter.com/widgets.js",
  FACEBOOK: `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=${FACEBOOK_SDK_VERSION}`,
  FACEBOOK_DEBUG: "https://connect.facebook.net/en_US/sdk/debug.js",
  INSTAGRAM: "https://platform.instagram.com/en_US/embeds.js",
  PYM: "https://pym.nprapps.org/pym.v1.min.js",
};

// Image crops
export const CROP_NAMES = {
  "16x9": "Axios.com, Facebook, Twitter",
  "4x3": "LinkedIn, Apple News",
  "1x1": "Google News, thumbnails",
};

// Convert our url paths to api paths
export const URL_TO_API = {
  story: "content",
  newsletter: "newsletters",
};

// Opposite of the above
export const API_TO_URL = Object.entries(URL_TO_API).reduce(
  (accum, [key, value]) => ({ ...accum, [value]: key }),
  {}
);

// Convert the backend's content_type flag to our url paths
export const CONTENT_TYPE_TO_URL = {
  content: "story",
  newsletter: "newsletter",
  "deep-dive": "deep-dive",
};

// Default Rubrics and Templates
export const RUBRICS = {
  DEFAULT: { name: "No text above headline", id: "default-rubric" },
};

export const TEMPLATES = {
  DEFAULT: { id: "no-template", name: "Standard story", type: "no-template" },
  FACTS_MATTER: {
    id: "00000000-0000-0000-0003-000000000001",
    name: "Facts Matter",
    type: "facts-matter",
  },
  // Expert Voices has a temporary template hardcoded into the frontend in the interim period between
  // only using it for newsletter chunks and in the future using it for stories too. There was never a way
  // to use templates in newsletters, so this is a bit of a hack that sets us up for the future hopefully.
  EXPERT_VOICES: {
    id: "ev-template",
    name: "Expert Voices",
    type: "expert-voices",
  },
};

// block style map (no underline)
export const STYLE_MAP = {
  UNDERLINE: {},
};

// topbar/sidebar links
export const STORY_EDITOR_LINKS = [
  {
    required: true,
    text: "Content",
    to: "content",
  },
  {
    required: true,
    text: "Metadata",
    to: "metadata",
  },
  {
    required: true,
    text: "Social & SEO",
    to: "social-seo",
  },
  {
    required: false,
    text: "Publishing",
    to: "publishing",
  },
  {
    required: false,
    text: "Previous versions",
    to: "previous-versions",
  },
];

export const VALIDATION_MESSAGE =
  "Please fill out the required fields highlighted in red.";
